import React from 'react';
import { OVERTIME_NOTE, PHONE_DISPLAY, PHONE_LINK } from '../data/locations';

// Бележка за цена извън работно време (+50 %) — важи и за двете локации.
function OvertimeNotice() {
  return (
    <div className="max-w-6xl mx-auto px-4 pt-4">
      <p className="border-2 border-red-800 bg-red-800 bg-opacity-10 text-red-800 rounded-lg px-4 py-3 text-center text-lg">
        <span aria-hidden="true">⏰ </span>
        <strong>{OVERTIME_NOTE}</strong>{' '}
        <span className="whitespace-nowrap">
          Обадете се на{' '}
          <a href={PHONE_LINK} className="underline font-bold hover:text-red-900">
            {PHONE_DISPLAY}
          </a>
          .
        </span>{' '}
        Важи и за двете локации.
      </p>
    </div>
  );
}

export default OvertimeNotice;
